<center-modal [modal]="modal" style="border-radius: 5px; width: 100%;">
  <ion-header>
    <ion-toolbar>
      <ion-title>
        Summary
      </ion-title>
      <ion-button slot="end" fill="clear" size="small" (click)="downloadSummary()">
        <ion-icon name="download-outline"></ion-icon>
      </ion-button>
    </ion-toolbar>
  </ion-header>
  <div class="content">

    <table>
      <tr>
        <th>
          Recon
        </th>
        <th *ngIf="bpayTransactions?.length" class="text-right">
          Bpay Received
        </th>
        <th class="text-right">
          Total In
        </th>
        <th class="text-right">
          Total Out
        </th>
        <th class="text-right">
          Balance
        </th>
      </tr>
      <tr *ngFor="let recon of uniqueRecon">
        <td [ngSwitch]="!!recon" class="text-center">
          <span *ngSwitchCase="true">
            {{ recon }}
          </span>
          <span *ngSwitchCase="false" class="italics">
            Unreconciled
          </span>
        </td>
        <td *ngIf="bpayTransactions?.length" class="text-right">
          {{ (( bpayTransactions | filterPropVals : 'recon' : recon ) | sumField : 'transaction') | currency }}
        </td>
        <td class="text-right">
          {{ (((( transactions | filterPropVals : 'recon' : recon ) | filterPropGreater : 'transaction' : 0) | sumField : 'transaction') - ((( transactions | filterPropVals : 'recon' : recon ) | filterBpayTotal) | sumField : 'transaction')) | currency }}
        </td>
        <td class="text-right">
          {{ ((( transactions | filterPropVals : 'recon' : recon ) | filterPropLesser : 'transaction' : 0) | sumField : 'transaction') | currency }}
        </td>
        <td class="text-right">
          {{ ((( transactions | filterPropVals : 'recon' : recon ) | sumField : 'transaction') - ((( transactions | filterPropVals : 'recon' : recon ) | filterBpayTotal) | sumField : 'transaction') + (( bpayTransactions | filterPropVals : 'recon' : recon ) | sumField : 'transaction')) | currency }}
        </td>
      </tr>
    </table>

  </div>
</center-modal>